/* EcoYoung: menu glowne (14.10.2026). Komputer: panel kategorii otwierany strzalka (klik, klawiatura)
   albo najazdem myszy z krotkim opoznieniem. Esc, klik w tlo albo wyjscie fokusem zamyka.
   Telefon: link z kotwica (#porownaj) na tej samej stronie zamyka szuflade. */
(function () {
  var HOVER = window.matchMedia ? window.matchMedia('(hover: hover) and (pointer: fine)') : { matches: false };
  function track(name, data) {
    try { if (window.dataLayer) window.dataLayer.push(Object.assign({ event: name }, data || {})); } catch (e) {}
  }

  function initNav(nav) {
    if (nav.__eyNav) return; nav.__eyNav = true;
    var items = Array.prototype.slice.call(nav.querySelectorAll('[data-ey-nav-item]'));
    var veil = nav.querySelector('[data-ey-nav-veil]');
    var current = null;
    var tOpen = null, tClose = null;

    function parts(li) {
      return { tog: li.querySelector('[data-ey-nav-tog]'), panel: li.querySelector('[data-ey-nav-panel]') };
    }
    function setVeil(show) {
      if (!veil) return;
      if (show) {
        var hdr = nav.closest('.header-wrapper') || nav.closest('header') || nav;
        var r = hdr.getBoundingClientRect();
        veil.style.setProperty('--ey-nav-top', Math.max(0, Math.round(r.bottom)) + 'px');
      }
      veil.hidden = !show;
    }
    function close(li, focusTog) {
      li = li || current;
      if (!li) return;
      var p = parts(li);
      p.panel.hidden = true;
      p.tog.setAttribute('aria-expanded', 'false');
      p.tog.setAttribute('aria-label', 'Rozwiń: ' + (p.tog.getAttribute('data-label') || ''));
      li.classList.remove('is-open');
      if (current === li) { current = null; setVeil(false); }
      if (focusTog) p.tog.focus();
    }
    function open(li, how) {
      if (current === li) return;
      if (current) close(current);
      var p = parts(li);
      p.panel.hidden = false;
      p.tog.setAttribute('aria-expanded', 'true');
      p.tog.setAttribute('aria-label', 'Zwiń: ' + (p.tog.getAttribute('data-label') || ''));
      li.classList.add('is-open');
      current = li;
      setVeil(true);
      track('ey_menu_open', { ey_menu: p.tog.getAttribute('data-label') || '', ey_how: how || 'klik' });
    }

    items.forEach(function (li) {
      var p = parts(li);
      if (!p.tog || !p.panel) return;
      p.tog.addEventListener('click', function (e) {
        e.preventDefault();
        clearTimeout(tOpen); clearTimeout(tClose);
        if (current === li) close(li); else open(li, 'klik');
      });
      li.addEventListener('mouseenter', function () {
        if (!HOVER.matches) return;
        clearTimeout(tClose);
        clearTimeout(tOpen);
        tOpen = setTimeout(function () { open(li, 'najazd'); }, current ? 0 : 140);
      });
      li.addEventListener('mouseleave', function () {
        if (!HOVER.matches) return;
        clearTimeout(tOpen);
        tClose = setTimeout(function () { if (current === li) close(li); }, 220);
      });
      li.addEventListener('focusout', function (e) {
        if (current === li && e.relatedTarget && !li.contains(e.relatedTarget)) close(li);
      });
      li.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && current === li) { e.stopPropagation(); close(li, true); }
      });
      p.panel.addEventListener('click', function (e) {
        var a = e.target.closest('a');
        if (!a) return;
        track('ey_menu_klik', { ey_menu: p.tog.getAttribute('data-label') || '', ey_cel: a.getAttribute('href') });
        var u;
        try { u = new URL(a.href, location.href); } catch (err) { return; }
        if (u.hash && u.pathname === location.pathname && u.search === location.search) close(li);
      });
    });
    if (veil) veil.addEventListener('click', function () { close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && current) close(current, true); });
    window.addEventListener('resize', function () { if (current) setVeil(true); });
    window.addEventListener('scroll', function () { if (current) setVeil(true); }, { passive: true });
  }

  function initDrawer() {
    var drawer = document.querySelector('header-drawer');
    if (!drawer || drawer.__eyDr) return; drawer.__eyDr = true;
    drawer.addEventListener('click', function (e) {
      var a = e.target.closest('#menu-drawer a');
      if (!a) return;
      var u;
      try { u = new URL(a.href, location.href); } catch (err) { return; }
      track('ey_menu_klik', { ey_menu: 'mobile', ey_cel: a.getAttribute('href') });
      if (u.hash && u.pathname === location.pathname && u.search === location.search && typeof drawer.closeMenuDrawer === 'function') {
        drawer.closeMenuDrawer(e);
      }
    });
  }

  function boot() {
    document.querySelectorAll('[data-ey-nav]').forEach(initNav);
    initDrawer();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
